(function () {
    angular
        .module('journey.veil', [])
        .service('veilService', [veilService]);

    function veilService() {

        //Flag to initialize veil
        var showVeil = false;

        //Display Veil
        this.displayVeil = function () {
            showVeil = true; 
        };

        //Hide Veil
        this.hideVeil = function () {
            showVeil = false;
        };

        //Current Veil State
        this.veilState = function () {
            return showVeil;
        };
    }
    
})();



// WEBPACK FOOTER //
// ./app/services/veil.service.js